import { colorTokens } from '../../../../shared/src/assets/theme/tokens'
import { ZingTheme } from '../../../../shared/src/assets/theme/types'
import { FONTS } from '../../../../shared/src/constants/fonts'

export const theme: ZingTheme = {
    colors: {
        white: colorTokens.white,
        black: colorTokens.black,
        primary: colorTokens.purple600,
        primaryLight: colorTokens.purple100,
        primaryDark: colorTokens.purple700,
        background: colorTokens.grey100,
        textPrimary: colorTokens.grey700,
        textSecondary: colorTokens.grey500,
        border: colorTokens.grey200,
        error: colorTokens.red,
        grey50:  colorTokens.grey50,
        blue100: colorTokens.blue100,
        blue200: colorTokens.blue200,
        grey400: colorTokens.grey400,
        grey300: colorTokens.grey300,
        grey600: colorTokens.grey600,
        grey800: colorTokens.grey800,
        purple50:        colorTokens.purple50,
        purple100:       colorTokens.purple100,
        purple300:       colorTokens.purple300,
        purple700:       colorTokens.purple700,
        success:         colorTokens.green500,
        successLight:    colorTokens.green100,
        warning:         colorTokens.yellow500,
        warningLight:    colorTokens.yellow100,
        highlight:       colorTokens.orange500,
        highlightLight:  colorTokens.orange100,
        secondaryHighlight: colorTokens.purple50,
        indigoShadow:     colorTokens.indigoShadow,
        shadowSmooth:     colorTokens.shadowSmooth,
        risk:             colorTokens.orange200,
        orangeDark:       colorTokens.orange600,
        sidebarBackground: `linear-gradient(180deg, ${colorTokens.grey800} 0%, ${colorTokens.purple600} 100%)`,
    },
    fonts: {
        body: FONTS.SUNDRY,
    },
}
